<template>
  <a-sub-menu :key="`${menuInfo.menuKey}`" v-bind="$props" v-on="$listeners" :selectedKeys="selectedKeys">
    <a-tooltip slot="title">
      <template slot="title">
        {{ menuInfo.name }}
      </template>
      <a-icon type="table" v-if="menuInfo.name === '公允价值表'" />
      <a-icon type="deployment-unit" v-if="menuInfo.name === '基金管理'" />
      <span>{{ menuInfo.name }}</span>
    </a-tooltip>
    <template v-for="item in menuInfo.children">
      <a-menu-item v-if="!item.children" :key="`${item.menuKey}`" @click="selectSideMenu(item)">
        <a-tooltip>
          <template slot="title">
            <span>{{ item.name }}{{ item.key }}</span>
            <span style="color: red; margin-left: 6px" v-if="item.ifRelease == false">(未发布)</span>
          </template>
          <span>{{ item.name }}{{ item.key }}</span>
          <span style="color: red; margin-left: 6px" v-if="item.ifRelease == false">(未发布)</span>
        </a-tooltip>
      </a-menu-item>
      <sub-menu v-else :key="`${item.menuKey}`" :menu-info="item" @titleClick="selectSideMenu(item)" />
    </template>
  </a-sub-menu>
</template>
<script>
import { Menu } from 'ant-design-vue';
import Event from '@/utils/event';
export default {
  name: 'SubMenu',
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    selectedId() {
      return this.$store.state.finance.menuId;
    }
  },
  methods: {
    // 路由跳转
    selectSideMenu(menu) {
      this.$store.commit('finance/setMenuId', menu.menuKey);
      // menuType
      // normal 中间页/授权列表/structureChart
      // fundType 人民币&美元主基金专项基金的title
      // fund 基金
      // fairTable 基金下具体报表
      if (menu.menuType === 'fund' || menu.menuType === 'fairTable') {
        let { fundId = '', fairId = '' } = menu;
        // fundType可以用来判断
        // 人民币主基金: 0,人民币专项基金: 1,美元主基金: 2,美元专项基金: 3
        // TODO 判断基金type跳转
        if (menu.fundType === 0) {
          this.$router.push(`/finance/RMB/main?fundId=${fundId}&fairId=${fairId}`);
        } else if (menu.fundType === 1) {
          this.$router.push(`/finance/RMB/special?fundId=${fundId}&fairId=${fairId}`);
        } else if (menu.fundType === 3) {
          this.$router.push(`/finance/RMB/feeder?fundId=${fundId}&fairId=${fairId}`);
        } else if (menu.fundType === 7) {
          this.$router.push(`/finance/RMB/investFund?fundId=${fundId}&fairId=${fairId}`);
        } else if (menu.fundType === 10) {
          this.$router.push(`/finance/USD/main?fundId=${fundId}&fairId=${fairId}`);
        } else if (menu.fundType === 11) {
          this.$router.push(`/finance/USD/special?fundId=${fundId}&fairId=${fairId}`);
        } else if (menu.fundType === 13) {
          this.$router.push(`/finance/USD/feeder?fundId=${fundId}&fairId=${fairId}`);
        } else {
          //
          this.$router.push(`/finance/fairvalueTable`);
        }
        this.$nextTick(() => Event.$emit('switchSideMenu', menu)); //先切换组件 再触发更新
      } else {
        this.$router.push(menu.fullPath);
      }
    }
  }
};
</script>
<style scoped lang="less">
// .selected {
//   background: rgba(228, 247, 255, 1);
//   color: #1890ff;
// }
</style>
